import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import LoadingOverlay from "react-loading-overlay-ts";
import {
  changeActiveComponent,
  getBillingReport,
  selectActiveDashboardComponent,
  selectBillingReport,
  selectBillingReportReq,
  selectBillingReportService,
  selectCurrentServiceReport,
  selectLoadingBillingReport,
} from "../DashboardSlice";
import ClipLoader from "react-spinners/ClipLoader";
import { serviceIdToName } from "../../facturacion/helpers/utils";
import { formatDateStandar } from "../../../../helpers/utils";

export const BillingReports = () => {
  const dispatch = useAppDispatch();
  const currentBillintReportRequest = useAppSelector(selectBillingReportReq);
  const billingReportData = useAppSelector(selectBillingReport);
  const loadingBillingReport = useAppSelector(selectLoadingBillingReport);
  const currentReportServiceName = useAppSelector(selectBillingReportService);
  const currentReportService = useAppSelector(selectCurrentServiceReport);
  const activeComponent = useAppSelector(selectActiveDashboardComponent);

  useEffect(() => {
    if (activeComponent !== "BillingReport") {
      dispatch(changeActiveComponent("BillingReport"));
    }
  }, [activeComponent]);

  const generateUserReportTable = () => {
    const userReport = billingReportData?.reportByUser || [];

    if (userReport.length === 0) {
      return (
        <h4
          style={{
            color: "white",
            fontSize: "15px",
            textAlign: "center",
          }}
        >
          No se encuentran registros
        </h4>
      );
    }

    const serviceOrder = [
      "COREID",
      "UPDATECOREID",
      "FORMS",
      "FIRMA",
      "FIRMA_BASIC",
      "PAGARE",
      "VALID",
      "BIO_AUTH",
      "BLACKLIST",
      "EXPERIAN",
      "HYPERFLOW",
      "SUPPORT",
      "VPN",
    ];

    const availableServices = new Set(
      userReport.flatMap((user) => Object.keys(user.services || {}))
    );

    const services = serviceOrder.filter((service) =>
      availableServices.has(service)
    );

    return (
      <div style={{ overflow: "auto", width: "100%" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead
            className="text-normal text-medium primary-color-35"
            style={{
              background: "rgba(0,0,0,0.4)",
              height: "30px",
              textAlign: "center",
            }}
          >
            <tr>
              <th></th>

              <th>Nombres </th>
              <th>Apellidos </th>
              <th>Identificación</th>

              {services.map((service) => (
                <React.Fragment key={service}>
                  <th>{serviceIdToName(service)} - Consumo</th>
                  <th>{serviceIdToName(service)} - IDs</th>
                </React.Fragment>
              ))}

              <th></th>
            </tr>
          </thead>

          <tbody
            className="text-normal text-x-small primary-color"
            style={{
              background: "rgba(0,0,0,0.2)",
              textAlign: "center",
            }}
          >
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>

              {services.map((service) => (
                <React.Fragment key={service}>
                  <td></td>
                  <td></td>
                </React.Fragment>
              ))}

              <td></td>
            </tr>

            {userReport.map((user, index) => (
              <tr
                key={`${user.userIdentification}-${index}`}
                className="list-hover"
                style={{
                  height: "30px",
                  cursor: "pointer",
                }}
              >
                <td></td>

                <td>{user.name || "-"}</td>
                <td>{user.lastName || "-"}</td>
                <td>{user.userIdentification || "-"}</td>

                {services.map((service) => {
                  const occurrence = user.services?.[service];

                  return (
                    <React.Fragment key={service}>
                      <td>{occurrence?.count ?? 0}</td>

                      <td>
                        {occurrence?.serviceIds?.length
                          ? occurrence.serviceIds.join(", ")
                          : "-"}
                      </td>
                    </React.Fragment>
                  );
                })}

                <td></td>
              </tr>
            ))}

            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>

              {services.map((service) => (
                <React.Fragment key={service}>
                  <td></td>
                  <td></td>
                </React.Fragment>
              ))}

              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };
  const generateReportTable = () => {
    if (currentReportService && currentReportService.length > 0) {
      const commonColumns = Object.keys(currentReportService[0]);
      return (
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginLeft: "1%",
          }}
        >
          <thead
            className="text-normal text-medium primary-color-35"
            style={{
              background: "rgba(0,0,0,0.4)",
              height: "30px",
              textAlign: "center",
            }}
          >
            <tr>
              <th></th>
              {commonColumns.map((column) => (
                <th>{column}</th>
              ))}
              <th></th>
            </tr>
          </thead>
          <tbody
            className="text-normal text-x-small primary-color"
            style={{ background: "rgba(0,0,0,0.2)", textAlign: "center" }}
          >
            <tr>
              <td></td>
              {commonColumns.map(() => (
                <td></td>
              ))}
              <td></td>
            </tr>
            {currentReportService.map((row, i) => (
              <tr
                key={i}
                className="list-hover"
                style={{ height: "30px", cursor: "pointer" }}
              >
                <td></td>
                {commonColumns.map((column) => {
                  const cellValue = row[column];
                  if (column.includes("Fecha")) {
                    return <td>{formatDateStandar(cellValue)}</td>;
                  } else if (column.includes("Facturable")) {
                    if (cellValue === true) {
                      return <td>Si</td>;
                    } else {
                      return <td>No</td>;
                    }
                  } else if (
                    column.includes("Estado") &&
                    typeof cellValue === "boolean"
                  ) {
                    if (cellValue === true) {
                      return <td>Autenticado</td>;
                    } else if (cellValue === false) {
                      return <td>No Autenticado</td>;
                    } else {
                      return <td>{cellValue}</td>;
                    }
                  } else if (typeof cellValue === "boolean") {
                    if (cellValue === true) {
                      return <td>Si</td>;
                    } else {
                      return <td>No</td>;
                    }
                  } else if (typeof cellValue === "number") {
                    if (cellValue === 0) {
                      return <td>0</td>;
                    } else {
                      //check if value has decimals
                      if (cellValue % 1 !== 0) {
                        return <td>{cellValue.toFixed(4)}</td>;
                      } else {
                        return <td>{cellValue}</td>;
                      }
                    }
                  } else if (cellValue && typeof cellValue === "object") {
                    if (Array.isArray(cellValue)) {
                      return (
                        <td key={column}>
                          {cellValue.map((item, index) => (
                            <div key={index}>
                              {Object.entries(item).map(([key, value]) => (
                                <div key={key}>
                                  <strong>{key}:</strong> {value?.toString()}
                                </div>
                              ))}
                            </div>
                          ))}
                        </td>
                      );
                    } else {
                      const keys = Object.keys(row[column]);
                      const values = Object.values(row[column]);
                      return (
                        <td>
                          {keys.map((key, i) => (
                            <div key={i}>
                              {key}: {values[i]}
                            </div>
                          ))}
                        </td>
                      );
                    }
                  } else {
                    return <td>{cellValue || "-"}</td>;
                  }
                })}
                <td></td>
              </tr>
            ))}
            <tr>
              <td></td>
              {commonColumns.map(() => (
                <td></td>
              ))}
              <td></td>
            </tr>
          </tbody>
        </table>
      );
    } else {
      return (
        <div
          style={{
            width: "96%",
            margin: "20px",
            height: "90%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            borderRadius: "10px",
          }}
        >
          <h3
            style={{
              color: "white",
              width: "50%",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            Para generar reportes seleccione el tipo de reporte y el periodo que
            desea consultar{" "}
          </h3>
        </div>
      );
    }
  };

  const showData = () => {
    if (currentBillintReportRequest.reportType === "USER") {
      return (
        <div
          style={{
            width: "96%",
            height: "100%",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            borderRadius: "10px",
            overflow: "auto",
          }}
        >
          <h4
            style={{
              color: "white",
              fontSize: "18px",
              fontWeight: "600",
              marginTop: "10px",
            }}
          >
            Consumo por Usuario
          </h4>

          {generateUserReportTable()}
        </div>
      );
    } else if (currentBillintReportRequest.reportType === "BILLING") {
      return (
        <div
          style={{
            width: "96%",
            height: "100%",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            borderRadius: "10px",
            overflow: "auto",
          }}
        >
          <h4
            style={{
              color: "white",
              fontSize: "18px",
              fontWeight: "600",
              marginTop: "10px",
            }}
          >
            {serviceIdToName(currentReportServiceName)}
          </h4>
          {generateReportTable()}
        </div>
      );
    } else {
      return (
        <div
          style={{
            width: "96%",
            margin: "20px",
            height: "90%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            borderRadius: "10px",
          }}
        >
          <h3
            style={{
              color: "white",
              width: "50%",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            Para generar reportes seleccione el tipo de reporte y el periodo que
            desea consultar{" "}
          </h3>
        </div>
      );
    }
  };

  return (
    <LoadingOverlay
      active={loadingBillingReport === "pending"}
      spinner={<ClipLoader color="white" size="100px" />}
    >
      <div
        style={{
          display: "flex",
          overflow: "auto",
          width: "100%",
          height: "90%",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {loadingBillingReport === "idle" ? (
          <div
            style={{
              width: "96%",
              margin: "20px",
              height: "90%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              borderRadius: "10px",
            }}
          >
            <h3
              style={{
                color: "white",
                width: "50%",
                textAlign: "center",
                fontSize: "20px",
              }}
            >
              Para generar reportes seleccione el tipo de reporte y el periodo
              que desea consultar{" "}
            </h3>
          </div>
        ) : (
          showData()
        )}
      </div>
    </LoadingOverlay>
  );
};
